import { CrosshairsQuestionIcon } from './CrosshairsQuestionIcon';

/**
 * author: Google
 * id 0842BFCE-4511-40B1-8E66-33CFED0A139B
 * name crosshairs-question
 * version: 4.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/crosshairs-question.svg
 * tags
 * - Navigation 
 * - Geographic Information System 
 */
export const GpsUnknownIcon = CrosshairsQuestionIcon;
export default GpsUnknownIcon